// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gj8D","fullView":"styles_fullView__17XFW"};